"use strict";

var React = window.React = require("react");
import { render } from 'react-dom'

var Frontpage = require("./ui/Frontpage/Frontpage.react");
var Login = require("./ui/Login/Login.react");
var AuthStore = require("./stores/AuthenticationStore");
var AuthActions   = require("./actions/AuthenticationActions");
var CompanyActions = require("./actions/CompanyActions");
var BankOverloardStore = require("./stores/BankOverloardStore");
var BankOverloardActions = require("./actions/BankOverloardActions");
var InventoryStore = require("./stores/InventoryStore");
var InventoryActions = require("./actions/InventoryActions");
var Header = require("./Header.react");
var Footer = require("./Footer.react");

var FourOFourErrorPage = require("./ui/ErrorPages/404ErrorPage.react");
var Inventory = require("./ui/Inventory/Inventory.react");
var InventoryItem = require("./ui/Inventory/InventoryItem.react");
var Market = require("./ui/Market/Market.react");
var Reports = require("./ui/Reports/Reports.react");
var Messages = require("./ui/Messages/Messages.react");
var Settings = require("./ui/Settings/Settings.react");
var SettingsTab = require("./ui/Settings/Settings/SettingsTab.react");
var NotificationTab = require("./ui/Settings/Notifications/NotificationTab.react");
var UsersTab = require("./ui/Settings/Users/UsersTab.react");
var DepartmentsTab = require("./ui/Settings/Departments/DepartmentsTab.react");
var LocationsTab = require("./ui/Settings/Locations/LocationsTab.react");
var BrandsTab = require("./ui/Settings/Brands/BrandsTab.react");
var TypesTab = require("./ui/Settings/Types/TypesTab.react");
var RolesTab = require("./ui/Settings/Roles/RolesTab.react");
var ImportTab = require("./ui/Settings/Import/ImportTab.react");
var UserProfile = require("./ui/UserProfile/Profile.react");

// ================
// Notification
// ================
var NotificationSystem = require('react-notification-system');
var NotificationStore = require('./stores/NotificationStore');
var NotificationActions = require('./actions/NotificationActions');

// ================
// Onboarding
// ================
var Welcome = require("./ui/Onboarding/Welcome.react");

// ================
// Routing packages
// ================
var Router = require('react-router').Router;
var Route = require('react-router').Route;
var Link = require('react-router').Link;
var IndexRoute = require('react-router').IndexRoute;
import { Redirect } from 'react-router';
import { browserHistory } from 'react-router';



var mountNode = document.getElementById("app");

// Styles
var main_less = require('../styles/main.less');
var materialDesignIconFont_css = require('../styles/material-design-iconic-font.min.css');
var reactWidgets_css = require('react-widgets/dist/css/react-widgets.css');

// Fonts, preferrably import fonts in css/less files to avoid requiring them in the js.
var material_design_iconic_font_woff = require('../fonts/Material-Design-Iconic-Font.woff');
var material_design_iconic_font_ttf = require('../fonts/Material-Design-Iconic-Font.ttf');
var material_design_iconic_font_svg = require('../fonts/Material-Design-Iconic-Font.svg');
var material_design_iconic_font_eot = require('../fonts/Material-Design-Iconic-Font.eot');

var rw_widgets_woff = require('../fonts/rw-widgets.woff');
var rw_widgets_ttf = require('../fonts/rw-widgets.ttf');
var rw_widgets_svg = require('../fonts/rw-widgets.svg');
var rw_widgets_eot = require('../fonts/rw-widgets.eot');

import Logo from '../images/logo.png';

var _ = require("underscore");

var LeftNavbar = React.createClass({
    getInitialState() {
        var authState = AuthStore.getState();
        return {
          fullName: authState.first_name + " " + authState.last_name,
          profilePicture: "",
          is_staff: authState.is_staff,
          accountName: authState.account_name,
        };
    },
    _toggleDockedLeftNavClick: function() {
        BankOverloardActions.toggleDockedLeftNavClick();
    },
    componentDidMount() {
        AuthStore.listen(this.onChange);
    },
    componentWillUnmount() {
        AuthStore.unlisten(this.onChange);
    },
    onChange: function () {
        var newstate = this.getInitialState();
        this.setState(newstate);
    },
    logout: function() {
        AuthActions.logoutUser();
    },
    render: function() {
        return (
            <nav className="left-sidebar">
              <div>
                <div className="logo">
                  <Link to="/inventory">
                    <img src={Logo} alt="Logo" />
                  </Link>
                </div>
                <ul>
                    <li className="inventoryListItem">
                        <Link to="/inventory" activeClassName="active">
                            <i className="fal fa-box-alt"></i>
                            <span className="nav-text">
                                Búnaðarskrá
                            </span>
                        </Link>
                    </li>
                    <li className="marketListItem">
                        <Link to="/market" activeClassName="active">
                            <i className="fal fa-shopping-cart"></i>
                            <span className="nav-text">
                                Sölutorg
                            </span>
                        </Link>
                    </li>
                    {(this.state.is_staff) ?
                        <span>
                            <li className="reportsListItem">
                                <Link to="/reports" activeClassName="active">
                                    <i className="fal fa-chart-bar"></i>
                                    <span className="nav-text">
                                        Yfirlit
                                    </span>
                                </Link>
                            </li>
                            <li className="settingsListItem">
                                <Link to="/settings" activeClassName="active">
                                    <i className="fal fa-cog"></i>
                                    <span className="nav-text">
                                        Stillingar
                                    </span>
                                </Link>
                            </li>
                        </span> :
                        <span />
                    }
                </ul>
              </div>
              <div className="profile">
                  <ul>
                    <li>
                      <i className="far fa-user-circle"></i>
                      <span className="nav-text">{this.state.fullName}</span>
                    </li>
                    <li>
                      <i className="far fa-home-lg"></i>
                      <span className="nav-text">{this.state.accountName}</span>
                    </li>
                    <li>
                      <a href="#" className="nav-text" onClick={this.logout}>
                        <i className="far fa-sign-out"></i>
                        <span className="nav-text">Skrá út</span>
                      </a>
                    </li>
                  </ul>
              </div>
            </nav>
        );
    }
});

var BankOverloard = React.createClass({
    getInitialState: function() {
        var newState = BankOverloardStore.getState();
        newState.is_staff = AuthStore.getState().is_staff;
        return newState;
    },
    componentWillMount: function() {
        // CompanyActions.getCompanyData();
        InventoryActions.getItems();
        NotificationStore.listen(this.onChangeNotification);
        BankOverloardStore.listen(this.onChange);
        AuthStore.listen(this.onAuthChange);
    },
    componentDidMount: function() {
        this._notificationSystem = this.refs.notificationSystem;
        // Check if the user is logged in before we show the app.
        // If the user is logged in, this function will also fetch
        // the user's info from the server.
        AuthActions.checkLoggedIn();
        Notification.requestPermission();
    },
    componentWillUnmount: function() {
        NotificationStore.unlisten(this.onChangeNotification);
        AuthStore.unlisten(this.onAuthChange);
        BankOverloardStore.unlisten(this.onChange);
    },
    onChange: function () {
        var newstate = this.getInitialState();
        this.setState(newstate);
    },
    onAuthChange: function() {
        var isLoggedIn = localStorage.getItem("token");
        //TODO: do this better
        if (isLoggedIn === null) {
            // Send the user to the login page if he doesn't have a valid token.
            browserHistory.push("/login");
        }

    },
    onChangeNotification: function(){
        var notification = NotificationStore.getState().notification;
        if(!_.isEmpty(notification)){
            var title = notification.title;
            var message = notification.message;
            var level = notification.level;

            //set up notification options if browser notifications are supported
            var options = {
                body: notification.message,
                icon: 'http://bunadarbankinn.is/img/logo_blue.png',
                tag: notification.level
            }

            this._addNotification(title, message, level);

            //Kóðinn að neðan er notaður ef við viljum nota browser notificationStore
            //taka þarf ákvörðun um það

            // // Let's check if the browser supports browser notifications
            // if (!("Notification" in window)) {
            //     console.log('notification in window')
            //     this._addNotification(title, message, level);
            // }
            //
            // // Let's check whether notification permissions have already been granted
            // else if (Notification.permission === "granted") {
            //     console.log('granted')
            //     // If it's okay let's create a notification
            //     var notification = new Notification(notification.title, options);
            // }
            //
            // // Otherwise, we need to ask the user for permission
            // else if (Notification.permission !== 'denied') {
            //     Notification.requestPermission(function (permission) {
            //         // If the user accepts, let's create a notification
            //         if (permission === "granted") {
            //             var notification = new Notification(notification.title, options);
            //         } else {
            //             this._addNotification(title, message, level);
            //         }
            //     }.bind(this));
            // } else {
            //     this._addNotification(title, message, level);
            // }


        }
    },
    _notificationSystem: null,
    _addNotification: function(title, message, level) {
        this._notificationSystem.addNotification({
            title: title,
            message: message,
            level: level,
            position: 'bl',
            autoDismiss: 5,
            onRemove: function(){
                NotificationActions.clearNotification();
            }
        });
    },

    render: function() {
        return (
            <div>
                <Welcome />
                <NotificationSystem ref="notificationSystem" style={false} />
                <LeftNavbar />
                <div id="app_content">
                    {/*<Header toggleLeftNav={this._toggleDockedLeftNavClick}/>*/}
                    <div className="Main">
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
});

var FrontpageApp = React.createClass({
    render: function() {
        return (
            <div className="FrontpageApp">
                {this.props.children}
            </div>
        );
    }
});

var routes = (
    <Router history={browserHistory}>
        <Route path="/" component={FrontpageApp}>
            <IndexRoute component={Login} />
            <Route path="/login" component={Login} />
        </Route>
        <Route name="home" path="/home" component={BankOverloard}>
            <IndexRoute component={Inventory} />
            <Route path="/inventory" component={Inventory} />
            <Route path="/item/:itemId" component={InventoryItem} />
            <Route name="market" path="/market" component={Market} />
            <Route name="settings" path="/settings" component={Settings}>
                <IndexRoute component={UsersTab} />
                <Route path="/settings/users" component={UsersTab}/>
                <Route path="/settings/departments" component={DepartmentsTab}/>
                <Route path="/settings/locations" component={LocationsTab}/>
                <Route path="/settings/types" component={TypesTab}/>
                <Route path="/settings/roles" component={RolesTab}/>
                <Route path="/settings/import" component={ImportTab}/>
                <Route path="/settings/notifications" component={NotificationTab}/>
                <Route path="/settings/settings" component={SettingsTab}/>
                <Route path="/settings/brands" component={BrandsTab} />
            </Route>
            <Route name="reports" path="/reports" component={Reports}/>
            <Route path="/messages" component={Messages}/>
            <Route path="/profile" component={UserProfile}/>
        </Route>
        <Route path="*" component={FourOFourErrorPage}/>
    </Router>
);

render(routes,mountNode);



// WEBPACK FOOTER //
// ./app/scripts/app.js